import { render, staticRenderFns } from "./WithdrawalRequestSidebar.vue?vue&type=template&id=f58fbd4a"
import script from "./WithdrawalRequestSidebar.vue?vue&type=script&lang=js"
export * from "./WithdrawalRequestSidebar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports